(function () {
  function ggmMbbDebug() {
    try {
      if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('ggm_mbb_debug') === '1') return true;
      return /[?&]ggm_mbb_debug=1(?:&|$)/.test(String(window.location && window.location.search ? window.location.search : ''));
    } catch (e) {
      return false;
    }
  }

  function logDebug() {
    if (!ggmMbbDebug() || typeof console === 'undefined' || !console.warn) return;
    try {
      console.warn.apply(console, arguments);
    } catch (e) {}
  }

  function initGgmMobileBottomBar(rootEl) {
    var bars = [];
    try {
      if (rootEl && rootEl.querySelectorAll) bars = Array.prototype.slice.call(rootEl.querySelectorAll('ggm-mobile-bottom-bar'));
      else bars = Array.prototype.slice.call(document.querySelectorAll('ggm-mobile-bottom-bar'));
    } catch (e) {
      bars = [];
    }
    if (!bars.length) return;

    bars.forEach(function (bar) {
      if (!bar || !bar.dataset) return;
      if (bar.dataset.ggmInit === '1') return;
      bar.dataset.ggmInit = '1';

      // Each instance keeps its own cleanup hooks to avoid double listeners in theme editor.
      bar._ggmCleanup = bar._ggmCleanup || [];

      function on(target, type, handler, options) {
        try {
          target.addEventListener(type, handler, options);
          bar._ggmCleanup.push(function () {
            try {
              target.removeEventListener(type, handler, options);
            } catch (e) {}
          });
        } catch (e) {
          logDebug('[ggm-mbb] addEventListener', e);
        }
      }

      function cleanup() {
        try {
          if (bar._ggmCleanup && bar._ggmCleanup.length) {
            bar._ggmCleanup.forEach(function (fn) {
              try {
                fn();
              } catch (e) {}
            });
          }
        } catch (e) {}
        bar._ggmCleanup = [];

        // Restore portaled dropdowns (if any)
        try {
          var containers = bar.querySelectorAll('[data-ggm-mbb-dropdown]');
          containers.forEach(function (c) {
            try {
              var dd = (c && c._ggmPortaledDropdown) || (c ? c.querySelector('.ggm-mbb-lang__dropdown') : null);
              if (dd && dd._ggmBackdrop && dd._ggmBackdrop.parentNode) dd._ggmBackdrop.parentNode.removeChild(dd._ggmBackdrop);
              dd._ggmBackdrop = null;
              if (dd && dd._ggmPortaled && dd._ggmPortaled.placeholder && dd._ggmPortaled.placeholder.parentNode) {
                dd._ggmPortaled.placeholder.parentNode.insertBefore(dd, dd._ggmPortaled.placeholder);
              }
              if (dd) {
                dd.classList.remove('ggm-mbb-portal');
                dd.style.cssText = '';
                dd.hidden = true;
                dd._ggmPortaled = null;
                dd._ggmReposition = null;
              }
              c._ggmPortaledDropdown = null;
            } catch (e) {}
          });
        } catch (e) {}

        // Restore portaled bar element itself
        try {
          if (bar._ggmBarPortaled && bar._ggmBarPortaled.placeholder && bar._ggmBarPortaled.placeholder.parentNode) {
            bar._ggmBarPortaled.placeholder.parentNode.insertBefore(bar, bar._ggmBarPortaled.placeholder);
          }
          bar._ggmBarPortaled = null;
          bar.classList.remove('ggm-mbb--docked');
        } catch (e) {}

        try {
          delete bar.dataset.ggmInit;
        } catch (e) {}
      }

      // Expose cleanup for section unload
      bar._ggmCleanupNow = cleanup;

      document.body.classList.add('ggm-mobile-bottom-bar-visible');

    // --- Detect actual theme (light/dark) from page styles ---
    // Many Shopify themes toggle dark mode via classes/attributes (not OS `prefers-color-scheme`).
    // We infer the current scheme from computed background color and update on class changes.
    (function syncSchemeFromPage() {
      function parseRgb(s) {
        if (!s) return null;
        // Support CSS variables like "255, 255, 255"
        var raw = String(s).trim();
        var m2 = raw.match(/^(\d+(\.\d+)?)[,\s]+(\d+(\.\d+)?)[,\s]+(\d+(\.\d+)?)/);
        if (m2) {
          return { r: parseFloat(m2[1]), g: parseFloat(m2[3]), b: parseFloat(m2[5]) };
        }
        var m = String(s).match(/rgba?\(([^)]+)\)/i);
        if (!m) return null;
        var parts = m[1].split(',').map(function (x) {
          return parseFloat(String(x).trim());
        });
        if (parts.length < 3) return null;
        return { r: parts[0], g: parts[1], b: parts[2] };
      }

      function luminance(rgb) {
        // 0..1, simple relative luminance
        var r = rgb.r / 255;
        var g = rgb.g / 255;
        var b = rgb.b / 255;
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
      }

      function computeScheme() {
        try {
          var rootCs = getComputedStyle(document.documentElement);
          // Prefer theme tokens (Dawn and many themes expose these)
          var bgVar = rootCs.getPropertyValue('--color-background');
          var fgVar = rootCs.getPropertyValue('--color-foreground');
          var rgbFromVars = parseRgb(bgVar) || parseRgb(fgVar);
          if (rgbFromVars) {
            // If background token is dark => scheme dark, otherwise light.
            // Using tokens avoids false "dark" detection on pages with dark hero images/overlays.
            return luminance(rgbFromVars) < 0.45 ? 'dark' : 'light';
          }

          // Fallback: computed background colors (can be unreliable if body is transparent over imagery)
          var bg = getComputedStyle(document.body).backgroundColor || rootCs.backgroundColor || '';
          var rgb = parseRgb(bg);
          if (!rgb) return null;
          return luminance(rgb) < 0.45 ? 'dark' : 'light';
        } catch (e) {
          return null;
        }
      }

      function apply() {
        // Allow forcing scheme from theme settings (useful for desktop testing).
        // data-ggm-scheme-mode: auto | light | dark
        var mode = null;
        try {
          mode = (bar.getAttribute('data-ggm-scheme-mode') || '').toLowerCase();
        } catch (e) {
          mode = null;
        }
        if (mode === 'dark' || mode === 'light') {
          bar.setAttribute('data-ggm-scheme', mode);
          return;
        }

        var s = computeScheme();
        if (!s) return;
        bar.setAttribute('data-ggm-scheme', s);
      }

      apply();
      try {
        // If scheme is forced, no need to observe page mutations.
        var forced = (bar.getAttribute('data-ggm-scheme-mode') || '').toLowerCase();
        if (forced === 'dark' || forced === 'light') return;

        var mo = new MutationObserver(function () {
          apply();
        });
        mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme', 'data-mode'] });
        bar._ggmCleanup.push(function () {
          try {
            mo.disconnect();
          } catch (e) {}
        });
      } catch (e) {}
    })();

    // Portal the bar itself to <body> (critical for iOS Safari).
    // If the theme wraps sections in transformed containers, `position: fixed` can behave like `absolute`
    // and the bar may disappear/glitch during scroll. Moving to <body> avoids that.
    (function portalBarOnce() {
      try {
        if (bar._ggmBarPortaled) return;
        var ph = document.createComment('ggm-mbb-placeholder');
        if (bar.parentNode) bar.parentNode.insertBefore(ph, bar);
        document.body.appendChild(bar);
        bar._ggmBarPortaled = { placeholder: ph };
      } catch (e) {}
    })();

    // Keep page content above the fixed bar (prevents covering footer).
    (function syncBodyPaddingToBarHeight() {
      try {
        var setH = function (h) {
          if (!h || h < 10) return;
          var next = Math.round(h) + 'px';
          var cur = '';
          try {
            cur = String(getComputedStyle(document.documentElement).getPropertyValue('--ggm-mbb-real-height') || '').trim();
          } catch (e0) {}
          if (cur === next) return;
          document.documentElement.style.setProperty('--ggm-mbb-real-height', next);
        };
        setH(bar.getBoundingClientRect().height || 0);
        var ro = new ResizeObserver(function (entries) {
          if (!entries || !entries[0]) return;
          var h = entries[0].contentRect.height || 0;
          if (h < 10) return;
          setH(h);
        });
        ro.observe(bar);
        bar._ggmCleanup.push(function () {
          try {
            ro.disconnect();
          } catch (e) {}
        });
      } catch (e) {}
    })();

    // Dynamic browser chrome (iOS/Android): lift bar via --ggm-mbb-vv-bottom on <html>.
    // Only visualViewport/window resize — never scroll (avoids repaint glitches).
    (function syncVvBottom() {
      var winT = 0;
      var vvRaf = 0;
      function scheduleVv() {
        if (vvRaf) return;
        vvRaf = requestAnimationFrame(function () {
          vvRaf = 0;
          apply();
        });
      }
      function apply() {
        try {
          var root = document.documentElement;
          if (bar.classList.contains('ggm-mbb--docked')) {
            root.style.setProperty('--ggm-mbb-vv-bottom', '0px');
            return;
          }
          var vv = window.visualViewport;
          var layoutH = window.innerHeight || root.clientHeight || 0;
          if (!vv || !layoutH) {
            root.style.setProperty('--ggm-mbb-vv-bottom', '0px');
            return;
          }
          var inset = layoutH - (vv.offsetTop + vv.height);
          if (!Number.isFinite(inset)) inset = 0;
          var next = Math.max(0, Math.round(inset)) + 'px';
          var prev = '';
          try {
            prev = root.style.getPropertyValue('--ggm-mbb-vv-bottom').trim();
          } catch (e1) {}
          if (prev === next) return;
          root.style.setProperty('--ggm-mbb-vv-bottom', next);
          if (ggmMbbDebug()) {
            logDebug('[ggm-mbb] --ggm-mbb-vv-bottom', next, {
              layoutH: layoutH,
              vvHeight: vv.height,
              vvOffsetTop: vv.offsetTop
            });
          }
        } catch (e) {
          try {
            document.documentElement.style.setProperty('--ggm-mbb-vv-bottom', '0px');
          } catch (e2) {}
        }
      }
      function scheduleWin() {
        try {
          clearTimeout(winT);
        } catch (e0) {}
        winT = window.setTimeout(function () {
          winT = 0;
          apply();
        }, 120);
      }
      apply();
      on(window, 'resize', scheduleWin, { passive: true });
      try {
        if (window.visualViewport) on(window.visualViewport, 'resize', scheduleVv, { passive: true });
      } catch (e3) {}
      on(window, 'orientationchange', scheduleWin, { passive: true });
      bar._ggmApplyVvBottom = apply;
      bar._ggmCleanup.push(function () {
        try {
          clearTimeout(winT);
        } catch (e4) {}
        try {
          if (vvRaf) cancelAnimationFrame(vvRaf);
        } catch (e4b) {}
        vvRaf = 0;
        try {
          document.documentElement.style.removeProperty('--ggm-mbb-vv-bottom');
        } catch (e5) {}
        try {
          delete bar._ggmApplyVvBottom;
        } catch (e6) {}
      });
    })();

    // Docking behaviour:
    // - Normal: bar is fixed and portaled to <body>, page has bottom padding.
    // - At the very end of the page: bar is inserted back into its original spot (static),
    //   so there's no "blank gap" after the footer (matches the old static behaviour).
    (function initDockToFooterEnd() {
      var ph = bar._ggmBarPortaled && bar._ggmBarPortaled.placeholder;
      if (!ph || !ph.parentNode) return;

      var raf = 0;
      function computeNearBottom() {
        var doc = document.documentElement;
        var scrollTop = window.scrollY || window.pageYOffset || 0;
        var scrollBottom = scrollTop + window.innerHeight;
        var docHeight = Math.max(doc.scrollHeight, doc.offsetHeight, doc.clientHeight);
        return scrollBottom >= docHeight - 2;
      }

      function setDocked(docked) {
        if (Boolean(bar._ggmDocked) === Boolean(docked)) return;
        bar._ggmDocked = Boolean(docked);

        if (docked) {
          // Insert before placeholder (original location in the DOM).
          ph.parentNode.insertBefore(bar, ph);
          bar.classList.add('ggm-mbb--docked');
          document.body.classList.add('ggm-mbb-docked');
        } else {
          document.body.appendChild(bar);
          bar.classList.remove('ggm-mbb--docked');
          document.body.classList.remove('ggm-mbb-docked');
        }
        try {
          if (typeof bar._ggmApplyVvBottom === 'function') bar._ggmApplyVvBottom();
        } catch (eVv) {}
      }

      function tick() {
        raf = 0;
        try {
          var nearBottom = computeNearBottom();
          // Hysteresis: once docked, undock only after scrolling up a bit.
          if (bar._ggmDocked) {
            var doc = document.documentElement;
            var scrollTop = window.scrollY || window.pageYOffset || 0;
            var scrollBottom = scrollTop + window.innerHeight;
            var docHeight = Math.max(doc.scrollHeight, doc.offsetHeight, doc.clientHeight);
            if (scrollBottom < docHeight - 80) setDocked(false);
          } else {
            if (nearBottom) setDocked(true);
          }
        } catch (e) {}
      }

      function schedule() {
        if (raf) return;
        raf = requestAnimationFrame(tick);
      }

      on(window, 'scroll', schedule, { passive: true });
      on(window, 'resize', schedule, { passive: true });
      on(document, 'visibilitychange', schedule, { passive: true });
      schedule();
    })();

    var inner = bar.querySelector('.ggm-mbb__inner');
    var cartButtons = bar.querySelectorAll('[data-ggm-mobile-cart]');
    var contactButtons = bar.querySelectorAll('[data-ggm-mobile-contact]');
    var dropdownContainers = bar.querySelectorAll('[data-ggm-mbb-dropdown]');

    (function initTapFeedback() {
      function tapClass(el) {
        if (!el || !el.classList) return;
        el.classList.add('ggm-tap');
        window.clearTimeout(el._ggmTapT);
        el._ggmTapT = window.setTimeout(function () {
          try {
            el.classList.remove('ggm-tap');
          } catch (e) {}
        }, 380);
      }

      on(bar, 'pointerdown', function (e) {
        var el = e.target && e.target.closest && e.target.closest('.ggm-mbb__item, .ggm-mbb-lang__toggle');
        if (!el || !bar.contains(el)) return;
        if (el.closest('.ggm-mbb-lang__dropdown')) return;
        tapClass(el);
      }, { passive: true });
    })();

    function isVisible(el) {
      if (!el) return false;
      if (el.hasAttribute('hidden')) return false;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
      var r = el.getBoundingClientRect();
      return r.width > 10 && r.height > 10;
    }

    function isCartOpen() {
      var cd = document.querySelector('cart-drawer');
      if (cd && (cd.hasAttribute('open') || cd.classList.contains('active') || cd.classList.contains('is-open') || isVisible(cd))) {
        return true;
      }

      var drawer =
        document.querySelector('#CartDrawer') ||
        document.querySelector('[id*="CartDrawer"]') ||
        document.querySelector('.cart-drawer') ||
        document.querySelector('.drawer--cart');
      if (isVisible(drawer)) return true;

      var overlay =
        document.querySelector('#CartDrawer-Overlay') ||
        document.querySelector('[id*="CartDrawer-Overlay"]') ||
        document.querySelector('.drawer-overlay') ||
        document.querySelector('.cart-drawer__overlay');
      if (isVisible(overlay)) return true;

      return false;
    }

    function syncCartState() {
      document.documentElement.classList.toggle('ggm-cart-open', isCartOpen());
    }

    cartButtons.forEach(function (button) {
      on(button, 'click', function () {
        var mode = button.getAttribute('data-cart-mode') || 'drawer';
        if (mode === 'page') {
          window.location.href = '/cart';
          return;
        }

        var cartIconBubble =
          document.querySelector('#cart-icon-bubble') ||
          document.querySelector('a[href="/cart"]') ||
          document.querySelector('.header__icon--cart');

        if (cartIconBubble) {
          cartIconBubble.click();
          return;
        }

        var cartDrawerTrigger = document.querySelector('[data-cart-open]') || document.querySelector('[aria-controls*="CartDrawer"]');

        if (cartDrawerTrigger) {
          cartDrawerTrigger.click();
          return;
        }

        window.location.href = '/cart';
      });
    });

    contactButtons.forEach(function (button) {
      on(button, 'click', function () {
        var fab = document.getElementById('ggmFab');
        if (fab) {
          fab.click();
          return;
        }

        var panel = document.getElementById('ggmPanel');
        var backdropWidget = document.getElementById('ggmBackdrop');

        if (panel) {
          panel.classList.add('show');
          panel.setAttribute('aria-hidden', 'false');
        }

        if (backdropWidget) {
          backdropWidget.classList.add('show');
          backdropWidget.setAttribute('aria-hidden', 'false');
        }
      });
    });

    // Swipe mode (> 5 items)
    if (inner && inner.children && inner.children.length > 5) {
      bar.classList.add('is-scrollable');
      function updateShadow() {
        var root = inner.closest('.ggm-mbb');
        if (!root) return;
        var isEnd = inner.scrollLeft + inner.clientWidth >= inner.scrollWidth - 10;
        root.classList.toggle('is-scrolled-end', isEnd);
      }
      on(inner, 'scroll', updateShadow, { passive: true });
      on(inner, 'scroll', repositionOpenDropdowns, { passive: true });
      on(window, 'resize', updateShadow, { passive: true });
      setTimeout(updateShadow, 100);
    }

    // --- Dropdowns (language/currency) ---
    function getDetailsEl(container) {
      return container.querySelector('details.ggm-mbb-lang__details');
    }

    function getDropdownEl(container) {
      return (container && container._ggmPortaledDropdown) || (container ? container.querySelector('.ggm-mbb-lang__dropdown') : null);
    }

    function getMsVar(name, fallback) {
      try {
        var raw = getComputedStyle(bar).getPropertyValue(name).trim();
        var n = parseInt(raw, 10);
        return Number.isFinite(n) ? n : fallback;
      } catch (e) {
        return fallback;
      }
    }

    function getPxVar(name, fallback) {
      try {
        var raw = getComputedStyle(bar).getPropertyValue(name).trim();
        var n = parseFloat(raw);
        return Number.isFinite(n) ? n : fallback;
      } catch (e) {
        return fallback;
      }
    }

    function closeAll(exceptContainer) {
      dropdownContainers.forEach(function (c) {
        if (exceptContainer && c === exceptContainer) return;
        closeContainer(c);
      });
    }

    function ensureBackdrop(dd) {
      if (!dd) return null;
      if (dd._ggmBackdrop && dd._ggmBackdrop.parentNode) return dd._ggmBackdrop;

      var b = document.createElement('div');
      b.className = 'ggm-mbb-portal-backdrop';
      b.style.position = 'fixed';
      b.style.left = '0';
      b.style.right = '0';
      b.style.top = '0';
      // keep bar clickable for "tap again to close"
      b.style.bottom =
        'calc(var(--ggm-mbb-height, 68px) + env(safe-area-inset-bottom) + var(--ggm-mbb-vv-bottom, 0px))';
      b.style.zIndex = '2147483646';
      b.style.background = 'transparent';
      b.style.pointerEvents = 'auto';
      b.addEventListener(
        'click',
        function () {
          closeAll();
        },
        { passive: true }
      );

      dd._ggmBackdrop = b;
      document.body.appendChild(b);
      return b;
    }

    function portalOnce(container) {
      var dd = getDropdownEl(container);
      if (!dd) return null;

      function syncDropdownThemeVars() {
        try {
          // When the dropdown is portaled to <body>, it no longer inherits CSS vars from the bar.
          // Copy the resolved theme vars onto the dropdown itself so backgrounds/text work in dark mode.
          var barCs = getComputedStyle(bar);
          var keys = [
            '--ggm-lang-dropdown-bg',
            '--ggm-lang-dropdown-text',
            '--ggm-lang-dropdown-border',
            '--ggm-lang-dropdown-active-bg',
            '--ggm-lang-dropdown-active-border'
          ];
          keys.forEach(function (k) {
            var v = barCs.getPropertyValue(k);
            if (v && String(v).trim()) dd.style.setProperty(k, String(v).trim());
          });
        } catch (e) {}
      }

      if (!dd._ggmPortaled) {
        var ph = document.createComment('ggm-mbb-dd-placeholder');
        dd.parentNode.insertBefore(ph, dd);
        dd._ggmPortaled = { placeholder: ph };
        container._ggmPortaledDropdown = dd;
        document.body.appendChild(dd);
        syncDropdownThemeVars();

        // Prevent "outside click" handlers from closing on dropdown interactions.
        dd.addEventListener(
          'click',
          function (e) {
            e.stopPropagation();
          },
          true
        );
        dd.addEventListener(
          'pointerup',
          function (e) {
            e.stopPropagation();
          },
          true
        );
      }

      // If dropdown moved out of the <form>, keep submit buttons associated with it.
      try {
        var form = container.querySelector('form');
        if (form && form.id) {
          var submits = dd.querySelectorAll('button[type="submit"], input[type="submit"]');
          submits.forEach(function (btn) {
            btn.setAttribute('form', form.id);
          });
        }
      } catch (e) {}

      function positionPortaledDropdown() {
        var type = container.getAttribute('data-ggm-mbb-dropdown') || 'language';
        // Offsets:
        // - Prefer shared `--ggm-mbb-ddx/--ggm-mbb-ddy` (same for language + currency)
        // - Otherwise fall back to language offsets for BOTH (keeps them aligned by default)
        // - If you still need per-type tweaks, they apply additively on top of shared/lang.
        var sharedX = getPxVar('--ggm-mbb-ddx', NaN);
        var sharedY = getPxVar('--ggm-mbb-ddy', NaN);
        var langX = getPxVar('--ggm-lang-ddx', 0);
        var langY = getPxVar('--ggm-lang-ddy', 0);
        var currX = getPxVar('--ggm-curr-ddx', 0);
        var currY = getPxVar('--ggm-curr-ddy', 0);

        var baseX = Number.isFinite(sharedX) ? sharedX : langX;
        var baseY = Number.isFinite(sharedY) ? sharedY : langY;
        var extraX = type === 'currency' ? currX : 0;
        var extraY = type === 'currency' ? currY : 0;
        var ddx = baseX + extraX;
        var ddy = baseY + extraY;
        var gap = getPxVar('--ggm-mbb-dd-gap', 12);
        var ddWidth = getPxVar('--ggm-mbb-dd-width', 260);
        var ddHeight = getPxVar('--ggm-mbb-dd-height', 240);

        // Requested: shrink dropdown width without changing its anchor/position.
        // - language: ~30% smaller
        // - currency: ~40% smaller
        ddWidth = ddWidth * (type === 'currency' ? 0.6 : 0.7);

        // Hard clamps to prevent "giant" dropdowns even if settings get weird.
        ddWidth = Math.max(180, Math.min(ddWidth, 300));
        ddHeight = Math.max(160, Math.min(ddHeight, 280));

        dd.hidden = false;
        dd.classList.add('ggm-mbb-portal');
        dd.style.position = 'fixed';
        syncDropdownThemeVars();

        // Align dropdown horizontally to its toggle (not screen center).
        try {
          var toggleEl = container.querySelector('.ggm-mbb-lang__toggle');
          var tr = toggleEl ? toggleEl.getBoundingClientRect() : null;
          var centerX = tr ? tr.left + tr.width / 2 : window.innerWidth / 2;

          // Keep dropdown fully on-screen (important near viewport edges).
          var viewportW = window.innerWidth || document.documentElement.clientWidth || 360;
          var widthPx = Math.min(viewportW * 0.92, Math.round(ddWidth));
          var half = widthPx / 2;
          var pad = 10; // visual breathing room from edges

          // Apply fine horizontal offset BEFORE clamping so it can't push off-screen.
          var desired = centerX + (ddx || 0);
          var clamped = Math.max(half + pad, Math.min(desired, viewportW - half - pad));
          dd.style.left = Math.round(clamped) + 'px';
        } catch (e) {
          dd.style.left = '50%';
        }

        dd.style.right = 'auto';
        dd.style.top = '';
        // Anchor vertically to the bar chrome (`.ggm-mbb__inner` top), not each toggle's rect.
        // Language vs currency toggles can differ slightly in height/content (flag vs symbol), which
        // made portaled dropdowns sit at different distances from the bar when keyed off summary.top.
        try {
          var innerBar = bar.querySelector('.ggm-mbb__inner');
          var innerRect = innerBar ? innerBar.getBoundingClientRect() : null;
          var toggleEl2 = container.querySelector('.ggm-mbb-lang__toggle');
          var toggleRect = toggleEl2 ? toggleEl2.getBoundingClientRect() : null;
          var refTop =
            innerRect && innerRect.height > 0
              ? innerRect.top
              : toggleRect
                ? toggleRect.top
                : null;
          var vv = window.visualViewport;
          var innerH = (vv && vv.height) ? vv.height : window.innerHeight || document.documentElement.clientHeight || 0;
          if (refTop != null && innerH) {
            var bottomPx = innerH - refTop + gap + ddy;
            dd.style.bottom = Math.round(bottomPx) + 'px';
          } else {
            dd.style.bottom =
              'calc(var(--ggm-mbb-height, 68px) + env(safe-area-inset-bottom) + var(--ggm-mbb-vv-bottom, 0px) + ' +
              gap +
              'px + ' +
              ddy +
              'px)';
          }
        } catch (e) {
          dd.style.bottom =
            'calc(var(--ggm-mbb-height, 68px) + env(safe-area-inset-bottom) + var(--ggm-mbb-vv-bottom, 0px) + ' +
            gap +
            'px + ' +
            ddy +
            'px)';
        }
        dd.style.zIndex = '2147483647';
        dd.style.width = 'min(92vw, ' + Math.round(ddWidth) + 'px)';
        dd.style.maxWidth = dd.style.width;
        // Avoid "giant" empty dropdowns: let content define height, only cap max-height.
        dd.style.height = 'auto';
        dd.style.maxHeight = 'min(44vh, ' + Math.round(ddHeight) + 'px)';
        dd.style.overflowY = 'auto';
        dd.style.boxSizing = 'border-box';

        // Offset is already applied before clamping.
        dd.style.marginLeft = '';
        dd.style.transform = 'translate3d(-50%, 0, 0) translateZ(0)';
        dd.style.webkitTransform = dd.style.transform;
        dd.style.transformOrigin = '50% 100%';
        dd.style.webkitTransformOrigin = '50% 100%';

        // Smooth re-anchoring while swiping the bar.
        // (Only during reposition calls; open/close controls opacity timing separately.)
        if (dd.dataset && dd.dataset.ggmMoving === '1') {
          dd.style.transitionProperty = 'opacity, left, bottom';
          dd.style.transitionDuration = '140ms';
          dd.style.transitionTimingFunction = 'cubic-bezier(0.16, 1, 0.3, 1)';
        }
      }

      positionPortaledDropdown();
      dd._ggmReposition = positionPortaledDropdown;

      if (!dd._ggmPortalInner) {
        var innerWrap = document.createElement('div');
        innerWrap.className = 'ggm-mbb-portal-inner';
        innerWrap.style.transformOrigin = '50% 100%';
        innerWrap.style.webkitTransformOrigin = '50% 100%';
        innerWrap.style.transitionProperty = 'transform';
        innerWrap.style.transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
        while (dd.firstChild) innerWrap.appendChild(dd.firstChild);
        dd.appendChild(innerWrap);
        dd._ggmPortalInner = innerWrap;
      }

      ensureBackdrop(dd);
      return dd;
    }

    function closeContainer(container) {
      var details = getDetailsEl(container);
      var sumToggle = details && details.querySelector('summary.ggm-mbb-lang__toggle');
      if (sumToggle) sumToggle.setAttribute('aria-expanded', 'false');
      if (details) details.open = false;
      container.classList.remove('is-open');

      var dd = getDropdownEl(container);
      if (dd) {
        dd.classList.remove('is-open');
        // Support markup that uses [hidden] on dropdown
        dd.hidden = true;
      }

      if (!dd || !dd._ggmPortaled) return;

      var type = container.getAttribute('data-ggm-mbb-dropdown') || 'language';
      var closeMs = getMsVar(type === 'currency' ? '--ggm-curr-close-ms' : '--ggm-lang-close-ms', 180);

      dd.style.transitionDuration = closeMs + 'ms';
      dd.style.transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
      dd.style.transitionProperty = 'opacity';
      dd.style.opacity = '0';
      dd.style.visibility = 'hidden';
      dd.style.pointerEvents = 'none';

      if (dd._ggmPortalInner) {
        dd._ggmPortalInner.style.transitionDuration = closeMs + 'ms';
        dd._ggmPortalInner.style.transform = 'scale3d(1, 0.96, 1)';
        dd._ggmPortalInner.style.webkitTransform = dd._ggmPortalInner.style.transform;
      }

      window.setTimeout(function () {
        dd.hidden = true;
        dd.style.width = '';
        if (dd._ggmBackdrop && dd._ggmBackdrop.parentNode) dd._ggmBackdrop.parentNode.removeChild(dd._ggmBackdrop);
        dd._ggmBackdrop = null;
        try {
          var sumFocus = container.querySelector('.ggm-mbb-lang__toggle');
          if (sumFocus && typeof sumFocus.focus === 'function') sumFocus.focus({ preventScroll: true });
        } catch (e2) {
          logDebug('[ggm-mbb] focus summary after close', e2);
        }
      }, closeMs + 50);
    }

    function openContainer(container) {
      closeAll(container);

      var details = getDetailsEl(container);
      if (details) details.open = true;

      requestAnimationFrame(function () {
        container.classList.add('is-open');

        var det = getDetailsEl(container);
        var sumOpen = det && det.querySelector('summary.ggm-mbb-lang__toggle');
        if (sumOpen) sumOpen.setAttribute('aria-expanded', 'true');

        var dd = getDropdownEl(container);
        if (dd) {
          dd.hidden = false;
          dd.classList.add('is-open');
        }
        // Always portal dropdowns to <body> so they:
        // - aren't clipped by swipe/overflow containers
        // - stay anchored to the correct button even when the bar is scrollable
        dd = portalOnce(container);
        if (!dd) return;

        var type = container.getAttribute('data-ggm-mbb-dropdown') || 'language';
        var openMs = getMsVar(type === 'currency' ? '--ggm-curr-open-ms' : '--ggm-lang-open-ms', 220);

        try {
          var w = dd.getBoundingClientRect().width;
          if (w && w > 0) dd.style.width = w + 'px';
        } catch (e) {}

        dd.hidden = false;
        dd.style.opacity = '0';
        dd.style.visibility = 'visible';
        dd.style.pointerEvents = 'auto';
        dd.style.transitionDuration = openMs + 'ms';
        dd.style.transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
        dd.style.transitionProperty = 'opacity';

        if (dd._ggmPortalInner) {
          dd._ggmPortalInner.style.transitionDuration = openMs + 'ms';
          dd._ggmPortalInner.style.transform = 'scale3d(1, 1, 1)';
          dd._ggmPortalInner.style.webkitTransform = dd._ggmPortalInner.style.transform;
        }

        requestAnimationFrame(function () {
          dd.style.opacity = '1';
          try {
            var firstBtn = dd.querySelector('button.ggm-mbb-lang__item, button[type="submit"]');
            if (firstBtn && typeof firstBtn.focus === 'function') firstBtn.focus({ preventScroll: true });
          } catch (e3) {
            logDebug('[ggm-mbb] focus first dropdown item', e3);
          }
        });
      });
    }

    // Reposition any open portaled dropdowns (e.g. while swiping the bar).
    function repositionOpenDropdowns() {
      try {
        if (repositionOpenDropdowns._raf) return;
        repositionOpenDropdowns._raf = requestAnimationFrame(function () {
          repositionOpenDropdowns._raf = 0;
          dropdownContainers.forEach(function (c) {
            if (!c.classList.contains('is-open')) return;
            var dd = getDropdownEl(c);
            if (dd && dd.dataset) dd.dataset.ggmMoving = '1';
            if (dd && dd._ggmPortaled && typeof dd._ggmReposition === 'function') dd._ggmReposition();
            if (dd && dd.dataset) {
              window.clearTimeout(dd._ggmMovingT);
              dd._ggmMovingT = window.setTimeout(function () {
                try {
                  dd.dataset.ggmMoving = '';
                } catch (e) {}
              }, 180);
            }
          });
        });
      } catch (e) {}
    }

    function isOpen(container) {
      return container.classList.contains('is-open');
    }

    function toggleContainer(container) {
      if (isOpen(container)) closeContainer(container);
      else openContainer(container);
    }

    if (dropdownContainers && dropdownContainers.length) {
      on(window, 'scroll', repositionOpenDropdowns, { passive: true });
      on(window, 'resize', repositionOpenDropdowns, { passive: true });
      try {
        if (window.visualViewport) on(window.visualViewport, 'resize', repositionOpenDropdowns, { passive: true });
      } catch (e) {}

      dropdownContainers.forEach(function (c) {
        closeContainer(c);
      });

      var lastPointerUpTs = 0;
      function handleToggleEvent(e) {
        var t = e && e.target;
        if (!t || !t.closest) return;

        if (e.type === 'pointerup') lastPointerUpTs = Date.now();
        if (e.type === 'click' && Date.now() - lastPointerUpTs < 750) return;

        if (t.closest('.ggm-mbb-lang__dropdown')) return;
        var toggleEl = t.closest('.ggm-mbb-lang__toggle');
        if (!toggleEl) return;
        var container = toggleEl.closest('[data-ggm-mbb-dropdown]');
        if (!container) return;
        e.preventDefault();
        e.stopPropagation();
        toggleContainer(container);
      }

      on(bar, 'pointerup', handleToggleEvent, { passive: false, capture: true });
      on(bar, 'click', handleToggleEvent, { passive: false, capture: true });

      on(document, 'click', function (e) {
          // Clicks inside dropdowns (portaled to <body>) should NOT close them.
          if (e.target && e.target.closest && e.target.closest('.ggm-mbb-lang__dropdown')) return;
          if (bar.contains(e.target)) return;
          closeAll();
      }, { passive: true });

      on(document, 'keydown', function (e) {
        if (e.key !== 'Escape') return;
        closeAll();
      });
    }

    try {
      window.__ggmMbbSnapshot = function () {
        var vv = window.visualViewport;
        var layoutH = window.innerHeight || 0;
        var inset = 0;
        if (vv && layoutH) inset = Math.max(0, Math.round(layoutH - (vv.offsetTop + vv.height)));
        var inner = bar.querySelector && bar.querySelector('.ggm-mbb__inner');
        var first =
          bar.querySelector &&
          bar.querySelector('.ggm-mbb__item, summary.ggm-mbb-lang__toggle, .ggm-mbb-lang__toggle');
        return {
          vvBottomVar:
            (document.documentElement && document.documentElement.style.getPropertyValue('--ggm-mbb-vv-bottom')) || '',
          vvInsetPx: inset,
          visualViewport: vv
            ? { height: vv.height, offsetTop: vv.offsetTop, offsetLeft: vv.offsetLeft, scale: vv.scale }
            : null,
          layoutInnerHeight: layoutH,
          docked: !!(bar.classList && bar.classList.contains('ggm-mbb--docked')),
          barRect: bar.getBoundingClientRect ? bar.getBoundingClientRect() : null,
          innerRect: inner && inner.getBoundingClientRect ? inner.getBoundingClientRect() : null,
          firstItemRect: first && first.getBoundingClientRect ? first.getBoundingClientRect() : null,
          hint: 'Add ?ggm_mbb_debug=1 to URL for vv-bottom logs; compare firstItemRect vs innerRect top-left.'
        };
      };
    } catch (eSnap) {}

    syncCartState();
    on(document, 'cart:refresh', syncCartState);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGgmMobileBottomBar);
  } else {
    initGgmMobileBottomBar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    try {
      initGgmMobileBottomBar((e && e.target) || document);
    } catch (err) {
      initGgmMobileBottomBar();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    try {
      var sectionId = e && e.detail && e.detail.sectionId;
      var root = (e && e.target) || document;
      var bars = root.querySelectorAll ? root.querySelectorAll('ggm-mobile-bottom-bar') : [];
      Array.prototype.forEach.call(bars, function (bar) {
        try {
          if (sectionId && bar && bar.getAttribute && bar.getAttribute('data-section-id') !== sectionId) return;
          if (bar && typeof bar._ggmCleanupNow === 'function') bar._ggmCleanupNow();
        } catch (e2) {}
      });
    } catch (e1) {}
  });
})();

